import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import { ErrorBoundary } from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { store } from 'store/configureStore';

import { Analytics } from 'components/Analytics/Analytics';
import { AnalyticsHeap } from 'components/AnalyticsHeap/AnalyticsHeap';
import { Chat } from 'components/Chat/Chat';
import { EmbeddedSetup } from 'components/EmbeddedSetup/EmbeddedSetup';
import { Routes } from 'components/Routes/Routes';
import { Sift } from 'components/Sift/Sift';
import { AuthUser } from 'containers/AuthUser/AuthUser';
import { TranslationProvider } from 'contexts/TranslationContext/TranslationContext';

import { embedded } from 'repositories';

import './EmbeddedEntry';

import './styles/main.scss';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchInterval: false,
      retry: 2,
    },
  },
});

const container = document.getElementById('payex-app-root')!;
const root = createRoot(container);

root.render(
  <ErrorBoundary>
    <Provider store={store.configure()}>
      <Analytics />
      <React.StrictMode>
        <AnalyticsHeap />
        <Sift />
        <AuthUser>
          <Router>
            <TranslationProvider>
              <QueryClientProvider client={queryClient}>
                {embedded.isEnabled() && <EmbeddedSetup />}
                <Routes />
                {!embedded.isEnabled() && <Chat />}
              </QueryClientProvider>
            </TranslationProvider>
          </Router>
        </AuthUser>
      </React.StrictMode>
    </Provider>
  </ErrorBoundary>,
);
